import * as api from "app/api/hr"
import * as absencesTableActions from "app/redux/absencesTable/absencesTable.actions"
import * as absencesTableSelectors from "app/redux/absencesTable/absencesTable.selectors"
import { SagaIterator } from "redux-saga"
import { call, put, select, takeLatest } from "redux-saga/effects"
import { getMonthRange } from "utils"
import * as notificationActions from "../notifications/notifications.actions"
import * as actions from "./requests.actions"
import { handleError } from "../errorHandler/errorHandler.saga"

export function* patchRequestsFlow(action: actions.PatchRequestsAction): SagaIterator {
  try {
    const { requestUpdates } = action.payload
    yield call(api.patchRequests, requestUpdates)
    const range = getMonthRange(requestUpdates[0].date)
    const userParams = yield select(absencesTableSelectors.getUserParams)
    yield put(absencesTableActions.getAbsences(range, userParams))
    yield put(actions.patchRequestsSuccess())
    yield put(
      notificationActions.show({
        id: "patchRequests",
        message: "confirmationDialog.requests.delete.message",
        variant: "success",
      }),
    )
  } catch (e) {
    yield put(actions.patchRequestsFail(e))
    yield call(handleError, { error: e })
  }
}

export function* postRequestFlow(action: actions.PostRequestsAction): SagaIterator {
  try {
    const { data } = action.payload
    const range = getMonthRange(data[0].date!)
    yield call(api.postRequest, data)
    const userParams = yield select(absencesTableSelectors.getUserParams)
    yield put(absencesTableActions.getAbsences(range, userParams))
    yield put(actions.postRequestsSuccess())
    yield put(
      notificationActions.show({
        id: "postRequest",
        message: "confirmationDialog.requests.create.message",
        variant: "success",
      }),
    )
  } catch (e) {
    yield put(actions.postRequestsFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* requestsSaga(): SagaIterator {
  yield takeLatest(actions.Types.PATCH, patchRequestsFlow)
  yield takeLatest(actions.Types.POST, postRequestFlow)
}
